import type { ReactElement } from "react"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import _t from "@core/i18n"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import type { SearchSectionFlatData } from "@gatsby-plugin-generic-page/fragments/searchSection"
import { mainSearchPromoText } from "@gatsby-plugin-generic-page/markdown/mainSearchSection"
import DomainInputField from "~/components/DomainInputField"

export type DomainSearchProps = {
  text?: SearchSectionFlatData["content"]
  domainExtensions?: SearchSectionFlatData["domainExtensions"]
  defaultExtensionIndex?: SearchSectionFlatData["defaultExtensionIndex"]
}

function DomainSearch({
  text,
  domainExtensions,
  defaultExtensionIndex,
}: DomainSearchProps): ReactElement<DomainSearchProps> {
  const isTextEmpty = !text || !text?.text

  const domainInputJsx = (
    <>
      <PushOrg
        bottomUnit={
          isTextEmpty ? undefined : { small: 20, medium: 12, large: 12 }
        }
      >
        <DomainInputField
          placeholderText={_t("domainSearch.mainDomainSearch.placeholder")}
          domainExtensions={domainExtensions}
          defaultExtensionIndex={defaultExtensionIndex}
          hasAnimatedPlaceholder
        />
      </PushOrg>

      {!isTextEmpty ? (
        <AlignContentOrg
          horizontalAlign={{
            small: "center",
            medium: "left",
            large: "left",
          }}
        >
          <MarkdownText components={mainSearchPromoText}>{text}</MarkdownText>
        </AlignContentOrg>
      ) : null}
    </>
  )

  return domainInputJsx
}

export default DomainSearch
